import { compose } from 'redux'
import { connect } from 'react-redux'

import componentCanCrash from '../../utils/components/componentCanCrash'

import SearchResults from '../../components/SearchResults'

export const mapStateToProps = state => {
  const {
    v1searchQuery: { isFetching, results = [] },
    v1airports: { items: airportResults },
  } = state

  return {
    isFetching: isFetching,
    results: results.map(result => {
      const departureAirport = airportResults.find(
        airport => airport.id === result.departureAirport
      )
      const arrivalAirport = airportResults.find(
        airport => airport.id === result.arrivalAirport
      )
      const departureAirportName = departureAirport
        ? departureAirport.name
        : result.departureAirport
      const arrivalAirportName = arrivalAirport
        ? arrivalAirport.name
        : result.arrivalAirport

      return {
        ...result,
        departureAirport: departureAirportName,
        arrivalAirport: arrivalAirportName,
      }
    }),
  }
}

export default compose(
  connect(mapStateToProps),
  componentCanCrash
)(SearchResults)
